import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectMenuComponent } from './select-menu.component';
import { AmountFormatPipe, StaticMsgModule, StaticMsgPipe, MetaUrlPipe, MetaUrlModule } from '@lib/pipes';
import { AmountFormatModule } from '@lib/pipes/amount-format/amount-format.module';

@NgModule({
  declarations: [SelectMenuComponent],
  exports: [SelectMenuComponent],
  providers: [StaticMsgPipe, AmountFormatPipe, MetaUrlPipe],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule, MetaUrlModule],
})
export class SelectMenuModule {}
